// pdw_carousel.js
import Splide from '@splidejs/splide';
import * as GridPkg from '@splidejs/splide-extension-grid';              // <— robuste: * as
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// Résout l'export quel que soit le mode (default ou nommé)
const Grid = (GridPkg && (GridPkg.Grid || GridPkg.default || GridPkg)) || null;

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.splide').forEach((root) => {
        // Anti double-mount
        if (root.dataset.splideMounted === '1') return;
        root.dataset.splideMounted = '1';

        // Lire la config JSON si présente (ex: data-splide='{"grid":{...}}')
        let conf = {};
        if (root.dataset.splide) {
            try { conf = JSON.parse(root.dataset.splide); } catch (e) { conf = {}; }
        }

        // Sinon, fallback à ta config "générique data-*"
        if (!Object.keys(conf).length) {
            const d = root.dataset;
            const perDefault = parseInt(d.perview, 10) || 1;
            conf = {
                type: d.type || 'loop',
                arrows: true,
                pagination: true,
                rewind: false,
                perPage: perDefault,
                perMove: 1,
                gap: (parseInt(d.gap, 10) || 0) + 'px',
                autoplay: false,
                padding: {
                    left: parseInt(d.peekbefore, 10) || 0,
                    right: parseInt(d.peekafter, 10) || 0,
                },
                breakpoints: {
                    1199: { perPage: parseInt(d.perviewlg, 10) || Math.max(1, perDefault - 1) },
                    991:  { perPage: parseInt(d.perviewmd, 10) || Math.max(1, perDefault - 1) },
                    767:  { perPage: parseInt(d.perviewsm, 10) || 1 },
                    575:  { perPage: parseInt(d.perviewxs, 10) || 1 },
                },
            };
        }

        // Construire la map d’extensions à monter
        const extensions = {};

        // AutoScroll UNIQUEMENT pour .partners
        const useAutoScroll = root.classList.contains('partners');
        if (useAutoScroll) {
            // Laisse autoplay à false quand AutoScroll est utilisé
            conf = {
                ...conf,
                autoplay: false,
                arrows: false,
                autoScroll: conf.autoScroll || {
                    speed: parseFloat(root.dataset.speed) || 1.2,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                },
            };
            extensions.AutoScroll = AutoScroll;
        }

        // Grid si demandé dans la conf (présence de conf.grid) ET si l’extension est valide
        const usesGrid = !!conf.grid;
        if (usesGrid && typeof Grid === 'function') {
            extensions.Grid = Grid;
        }

        // DEBUG (optionnel) : vois ce qu'on monte réellement
        // console.log('Splide mount on', root, 'extensions:', Object.keys(extensions));

        const inst = new Splide(root, conf);
        inst.mount(extensions);
        root.__splide = inst;
    });
});